import { t } from "@/i18n-js/instance";
import { UsageDetailsSection } from "./UsageDetailsSection";
import { UsageMetric } from "./UsageMetric";

const localeRoot = "settings.billing.manage_billing.usage_details.api";

export const APIUsageDetails = () => (
  <UsageDetailsSection title={t(`${localeRoot}.title`)} showMenu>
    <UsageMetric
      title={t(`${localeRoot}.member_api_requests.title`)}
      progress={50}
      description={t(`${localeRoot}.member_api_requests.description`)}
      price={t(`${localeRoot}.member_api_requests.price`)}
    />
    <UsageMetric
      title={t(`${localeRoot}.admin_api_requests.title`)}
      progress={50}
      description={t(`${localeRoot}.admin_api_requests.description`)}
      price={t(`${localeRoot}.admin_api_requests.price`)}
    />
  </UsageDetailsSection>
);
